import {ChangeDetectorRef, Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UtilService} from '../../services/util.service';
import {ValidationConstraint} from '../../domain/validation-constraint';
import * as _ from 'lodash';

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit, OnChanges, DoCheck {

    @Input() errors: any;
    @Input() modelPath: string;
    @Input() styleClass: string;
    @Input() validationConstraints: ValidationConstraint[];
    @Input() objToValidate: any;
    @Input() errorPath: string; // if error path not equal to model path
    // @Input() constraintPath: string; // if constraint path not equal to model path
    public valid = true;
    private componentValidationConstraints: ValidationConstraint[];

    public error: string;

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.errorPath = this.errorPath || this.modelPath;
        // this.constraintPath = this.constraintPath || this.errorPath;
        this.updateValidationConstraints();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valid = true;
        this.error = null;

        if (changes.errors !== undefined && changes.errors.currentValue !== undefined && !_.isEmpty(changes.errors.currentValue)) {
            this.errorPath = this.errorPath || this.modelPath;
            this.error = UtilService.getObjByPath(changes.errors.currentValue, this.errorPath);
            if (this.error) {
                this.valid = false;
            }
        }
        if (changes.objToValidate) {
            this.updateValidationConstraints();
        }

    }

    private updateValidationConstraints() {
        if (this.error && this.validationConstraints !== null && this.modelPath) {
            this.componentValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
            this.cd.markForCheck();
        }
    }

    ngDoCheck(): void {
        if (this.componentValidationConstraints &&
            this.componentValidationConstraints.length > 0 && this.error && this.errorPath) {
            this.validateObject();
        } else if (this.modelPath.indexOf('additionalCosts.') > -1 && this.error) {
            this.validateAdditionalCosts();
        }
    }

    private validateObject() {
        this.valid = true;
        const obj: any = UtilService.getObjByPath(this.objToValidate, this.modelPath);
        for (const constraint of this.componentValidationConstraints) {
            if (this.validate(constraint, this.objToValidate) && this.valid) {
                switch (constraint.pattern) {
                    case 'NULL':
                        this.valid = obj === null;
                        break;
                    case 'NOT_NULL':
                        this.valid = !!obj;
                        break;
                    case 'NOT_EMPTY':
                        this.valid = obj !== null && obj !== '' && obj.length > 0;
                        break;
                    case 'MIN':
                        if (constraint.parameters) {
                            const minValue = parseInt(constraint.parameters, 10);
                            if (obj != null && obj < minValue) {
                                this.valid = false;
                            }
                        }
                        break;
                    case 'MAX':
                        if (constraint.parameters) {
                            const maxValue = parseInt(constraint.parameters, 10);
                            if (obj > maxValue) {
                                this.valid = false;
                            }
                        }
                        break;
                    case 'MIN_LENGTH':
                        if (constraint.parameters) {
                            const minLength = parseInt(constraint.parameters, 10);
                            if (Array.isArray(obj)) {
                                this.valid = obj.length > minLength;
                            } else {
                                this.valid = obj.toString().trim().length >= minLength;
                            }
                        }
                        break;
                    case 'RANGE':
                        if (constraint.parameters) {
                            const arr = constraint.parameters.split(';');
                            if (arr.length === 2) {
                                const minValue = parseInt(arr[0], 10);
                                const maxValue = parseInt(arr[1], 10);
                                if (obj < minValue || obj > maxValue) {
                                    this.valid = false;
                                }
                            }

                        }
                        break;
                    case 'TRUE':
                        this.valid = obj === true;
                        break;
                    case 'NOT_BLANK':
                        this.valid = obj !== null && obj.toString().trim() !== '';
                        break;
                    default:
                        const re = new RegExp(constraint.pattern);
                        this.valid = re.test(obj.toString());
                }
            }
        }
        this.cd.markForCheck();

    }

    private validateAdditionalCosts() {
        if (this.objToValidate.isChecked) {
            this.valid = true;
            if (this.objToValidate.fields && this.objToValidate.fields.length > 0) {
                for (const field of this.objToValidate.fields) {
                    if (field.isOptional === undefined || field.isOptional === false) {
                        if (field.value === null && field.type !== 'LABEL') {
                            this.valid = false;
                        }
                    }

                }
            }
        }
    }

    private validate(constraint: ValidationConstraint, objToValidate: any) {
        if (!constraint.condition) {
            return true;
        }
        switch (constraint.conditionType) {
            case 'SETTING':
                break;
            case 'FIELD':
                const obj = _.get(objToValidate, constraint.condition);
                if (obj && obj.toString() === constraint.conditionValue) {
                    return true;
                }
                break;
        }
        return false;
    }
}
